(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.valunna-pack-card');
    if (!button) return;
    const offers = button.closest('.valunna-pack-offers');
    if (!offers || offers.dataset.pending === 'true') return;

    offers.dataset.pending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    const quantity = Number(button.dataset.packQuantity);
    const discountCode = button.dataset.discountCode;
    const rootUrl = offers.dataset.rootUrl || '/';
    const cartUrl = offers.dataset.cartUrl || '/';
    const updates = {};
    updates[offers.dataset.lineKey] = quantity;

    try {
      const response = await fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Cart update failed');

      window.location.assign(
        rootUrl + 'discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(cartUrl)
      );
    } catch (error) {
      offers.dataset.pending = 'false';
      button.disabled = false;
      button.removeAttribute('aria-busy');
      const status = offers.querySelector('.valunna-pack-offers__status');
      if (status) status.textContent = 'No pudimos actualizar el pack. Inténtalo nuevamente.';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
